<template>
    <div>
        <el-dialog title="余额充值" width="500px" :visible.sync="rechargeShow" :before-close="rechargeClose"
            :append-to-body="true" :close-on-click-modal="false">
            <div class="blueInfo payTip">
                <p>账户余额说明：</p>
                <p>1.平台使用AI识别所产生的费用，可在账户余额中扣除</p>
                <!-- <p>2.平台使用AI识别所产生的费用，可在账户余额中扣除</p> -->
            </div>

            <div>
                <div>充值金额</div>
                <div class="payAmount flex">
                    <div :class="activeAmount === item.value ? 'payAmount-item active' : 'payAmount-item'"
                        v-for="item in amountList" :key="item.value" @click="amountClick(item)">{{ item.label }}</div>
                </div>
                <el-input v-if="activeAmount === 0" size="large" v-model="customAmount" @input="amountInput"
                    placeholder="请输入自定义充值金额">
                    <template slot="append">元</template>
                </el-input>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="aliPay" type="primary" size="large">支付宝支付</el-button>
            </span>
        </el-dialog>
        <el-dialog title="扫码支付" width="30%" :visible.sync="codeVisible" :before-close="dialogClose"
            :append-to-body="true">
            <div class="qrcode-box">
                <vue-qr class="qrcode" :text="qrcodeUrl" :size="200"/>
            <div class="qrcode-tip">打开手机支付宝，扫一扫付款</div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import VueQr from "vue-qr";
export default {
    components: {
        VueQr
    },
    data() {
        return {
            amountList: [
                {
                    label: "100元",
                    value: 100
                },
                {
                    label: "200元",
                    value: 200
                },
                {
                    label: "500元",
                    value: 500
                },
                {
                    label: "自定义",
                    value: 0
                }
            ],
            activeAmount: null,
            customAmount: null,
            rechargeShow: false,
            codeVisible: false,
            qrcodeUrl: '',
            timer: null,
            organizationId: null,
            channel: null
        };
    },
    methods: {
        amountClick(item) {
            this.customAmount = null;
            this.activeAmount = item.value;
        },
        rechargeClose() {
            this.rechargeShow = false;
        },
        /**
         * 打开充值界面的方法
         * 
         * @param {string} channel - 默认值为"AI_FEE"，表示充值渠道
         * @param {string|null} organizationId - 机构ID，用于指定需要充值的机构，默认为null，null为平台
         */
        rechargeOpen(channel = "AI_FEE", organizationId = null) {
            this.rechargeShow = true;
            this.organizationId = organizationId;
            this.channel = channel;
        },
        amountInput(val) {
            this.customAmount = this.numberInput(val, 0, 5000);
        },
        aliPay() {
            if (this.activeAmount === 0 && !this.customAmount || this.customAmount === '0') {
                this.$message.warning('请输入充值金额')
                return
            }
            if (!this.activeAmount && this.activeAmount !== 0) {
                this.$message.warning('请选择充值金额')
                return
            }
            if(parseFloat(this.customAmount) == 0) {
                this.$message.warning('请输入充值金额')
                return
            }
            this.rechargeShow = false;
            this.TopUpAmountClick(this.activeAmount || this.customAmount)
        },
        dialogClose() {
            this.qrcodeUrl = ""
            if (this.timer) {
                clearInterval(this.timer);
            }
            this.codeVisible = false;
            this.rechargeShow = true
        },
        //立即充值
        async TopUpAmountClick(amount) {
            let data = await this.$axios.post("/api/v1/pay/recharge", {
                amount: amount,
                channel: this.channel,
                organizationId: this.organizationId
            });

            if (data.code == 1) {
                this.codeVisible = true;
                this.qrcodeUrl = data.data.qrCode;
               

                this.timer = setInterval(async () => {
                    let res = await this.$axios.get("/api/v1/pay/recharge/status", {
                        outTradeNo: data.data.outTradeNo,
                    });
                    if (res?.data?.status == 2) {
                        clearInterval(this.timer);
                        this.qrcodeUrl = "";
                        this.codeVisible = false;
                        this.activeAmount = null;
                        this.customAmount = null;
                        this.$message.success("充值成功");
                        this.$emit('success', true)
                    }
                }, 5000);
            }
        },

    }
};
</script>

<style lang="less" scoped>
.payTip {
    color: #409EFF;
    border: 1px solid #409EFF;
    border-radius: 5px;
    background: #409EFF11;
}

.payAmount {
    justify-content: space-between;
    margin: 10px 0;

    .payAmount-item {
        width: 22%;
        border: 1px solid #666;
        padding: 10px;
        box-sizing: border-box;
        border-radius: 5px;
        text-align: center;

        &:hover {
            cursor: pointer;
        }
    }

    .active {
        color: #409EFF;
        border: 1px solid #409EFF;
        background: #409EFF11;
    }
}

.dialog-footer {
    width: 100%;

    button {
        width: 100%;
    }
}
.qrcode-box {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.qrcode {
    display: flex;
    justify-content: center;
}

.qrcode-tip {
    margin-top: 15px;
    text-align: center;
}
</style>